/* RESPONSIBLE TEAM: team-frontend-tech */
import Block from './block';
import { notEmpty } from '@ember/object/computed';
import { fragmentArray } from 'ember-data-model-fragments/attributes';

export default Block.extend({
  attachments: fragmentArray('common/blocks/attachment'),
  hasContent: notEmpty('attachments'),
});
